import type { Reducer } from 'redux';
import { Actions } from '@/redux/quizzes/actions';
import type { QuizzesState, QuizzesAction } from '@/redux/quizzes/types';

export const initialState: QuizzesState = {
  quizzes: [],
  available: 0,
  quizQueue: []
};

export default ((state = initialState, action: QuizzesAction) => {
  switch (action.type) {
    case Actions.SetQuizzesData:
      return { ...state, ...action.data };

    case Actions.SetQuizzesDataFail:
      return { ...state, error: action.error };

    case Actions.SetQuizQueue:
      return { ...state, quizQueue: action.queue ?? [] };

    case Actions.SetQuizQueueFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<QuizzesState, QuizzesAction>;
